import * as React from 'react';
import { IconProps } from '../types';

const IcImage = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M5.5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 .649.937L15.792 9.293a1 1 0 0 1 1.415 0l3.293 3.293V5a1 1 0 0 0-1-1h-14Zm17 10.999V5a3 3 0 0 0-3-3h-14a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4.001Zm-2 .415-4-4L7.914 20H19.5a1 1 0 0 0 1-1v-3.586ZM9 8a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-2.5.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcImage;
